import { render, staticRenderFns } from "./StickedToBottomButton.vue?vue&type=template&id=4e849164"
import script from "./StickedToBottomButton.vue?vue&type=script&lang=js"
export * from "./StickedToBottomButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports